import { render, staticRenderFns } from "./SplitRulesModal.vue?vue&type=template&id=258b5cdf"
import script from "./SplitRulesModal.vue?vue&type=script&lang=js"
export * from "./SplitRulesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports